/**
 * Locale translations: zh (Chinese).
 * Keys and structure are shared across all locale files.
 */
export const zh = {
  // Common
  common: {
    loading: "正在加载...",
    error: "错误",
    sort: "排序",
    sortAsc: "升序",
    sortDesc: "降序",
    save: "保存",
    cancel: "取消",
    delete: "删除",
    remove: "移除",
    edit: "编辑",
    view: '查看',
    copy: "复制",
    create: "创建",
    update: "更新",
    search: "搜索",
    actions: "动作",
    code: "编码",
    all: "全部",
    clear: "清除",
    filter: "筛选",
    yes: "是",
    no: "否",
    confirm: "确认",
    close: "关闭",
    select: "选择",
    active: "活动",
    inactive: "非活动",
    success: "成功",
    updated: "已更新",
    created: "已创建",
    deleted: "已删除",
    confirmDelete: "您确定要删除吗？",
    errorOccurred: "发生了一个错误",
    noData: "暂无数据",
    status: "状态",
    show: "显示",
    hide: "隐藏",
    searchPlaceholder: "搜索...",
    allStatuses: "所有状态",
    clearFilters: "清除筛选",
    newRecord: "新记录",
    noPermission: "没有权限",
    statusDistribution: "状态分布",
    rows: "行",
    firstPage: "第一页",
    previousPage: "上一页",
    nextPage: "下一页",
    lastPage: "最后一页",
    page: "页",
    optional: "可选",
    saving: "正在保存...",
    deleteConfirmTitle: "确认删除",
    deleteWarning: "此操作无法撤销！",
    autoTranslate: "自动翻译",
    autoTranslateSuccessCount: "已自动翻译 {count} 个项目。",
    autoTranslateNoSource: "未找到源翻译。",
    enterTargetLanguage: "请选择目标语言。",
    sourceLanguageLabel: "源语言（您的界面）",
    targetLanguage: "目标语言",
    sourceAndTargetMustDiffer: "源语言和目标语言必须不同。",
    context: "上下文",
    key: "键",
    value: "值",
    locale: "语言",
    auto: "自动",
    manual: "手动",
    manageLocales: "语言管理",
    activeLocalesDescription: "选择活动语言。仅作为设置保存。",
    updateUntranslatedFields: "同步新字段",
    syncEntriesResult: "已同步 {count} 条新翻译条目。",
    syncDeletedResult: "已删除 {count} 条过时条目。",
    selectSourceLanguageForSync: "内容是什么语言？",
    sourceLanguage: "源语言",
    originalShort: "原文",
    languageNames: { en: "英语", tr: "土耳其语", de: "德语", fr: "法语", es: "西班牙语", ar: "阿拉伯语", it: "意大利语", ja: "日语", zh: "中文", ru: "俄语" } as Record<string, string>,
    perPage: "每页显示",
    darkMode: "暗色模式",
    lightMode: "亮色模式",
    copyright: "© {year} QubePro. 保留所有权利。",
    translationRates: "翻译率",
    profileMenu: "个人中心",
    manageYourAccount: "管理账号",
    adminConsole: "管理控制台",
    serverConfiguring: "服务器配置中，请稍候...",
    productName: "管理系统",
  },

  portal: {
    searchPlaceholder: "搜索应用...",
    noAppsFound: "未找到应用。",
    quickLinks: "快捷链接",
    console: "管理控制台",
    lastLogin: "最后登录",
    apps: {
      core: { name: "管理中心", description: "在集中平台上管理公司、组织、用户、角色和权限。" },
      bi: { name: "分析中心", description: "从您的数据中创建报告和仪表板。将业务数据转化为见解。" },
      bpm: { name: "流程管理", description: "在数字环境中启动、跟踪并完成内部申请、审批和任务。" },
      support: { name: "服务支持", description: "管理客户请求和工单。在一个地方跟踪并解决问题。" },
      agent: { name: "智能自动化", description: "使用机器人和代理自动化常规任务。与您的工具集成。" },
      ai: { name: "AI预测", description: "使用人工智能模型进行数据分析和预测。改进规划和决策。" },
      erp: { name: "企业套件", description: "财务、销售、库存和运营模块。在一个平台上运行您的业务。" },
      pms: { name: "项目管理", description: "计划项目、分配任务、跟踪进度并与团队协作。" },
      crm: { name: "客户管理", description: "管理联系人、潜在客户、机会、合同和销售管道。" },
    },
    menus: {
      core_dashboard: "仪表板",
      core_companies: "公司管理",
      core_organizations: "组织管理",
      core_roles: "角色管理",
      core_users: "用户管理",
      core_groups: "群组管理",
      core_emails: "邮件账号",
      core_data_sources: "数据源",
      core_settings_company: "公司设置",
      core_settings_user: "个人设置",
      core_translations: "翻译管理",
    },
  },

  panel: {
    apps: {
      crm: { name: "CRM", footerName: "CRM" },
      accounting: { name: "财务会计" },
      finance: { name: "财务" },
      procurement: { name: "采购与供应" },
      inventory: { name: "库存管理" },
      purchase: { name: "采购管理" },
      sales: { name: "销售管理" },
      manufacturing: { name: "制造管理" },
      assets: { name: "资产" },
      hr: { name: "人力资源" },
      project: { name: "项目管理" },
      timesheet: { name: "工时表" },
      documents: { name: "文档中心" },
      pos: { name: "收银点" },
      rental: { name: "租赁管理" },
      dashboard: { name: "报表中心" },
    },
    appsLabel: "应用程序",
    settingsLabel: "系统设置",
    coreLabel: "管理中心",
    backToHome: "返回首页",
  },

  errors: {
    unknown: "发生位置错误",
    network: "无法连接到服务器。请检查您的网络连接。",
    timeout: "请求超时。请重试。",
    badRequest: "无效请求",
    unauthorized: "登录已失效。请重新登录。",
    forbidden: "您没有执行此操作的权限。",
    notFound: "找不到资源",
    tooManyRequests: "请求过于频繁。请稍后再试。",
    internalServerError: "服务器错误。请稍后再试。",
    badGateway: "服务器暂时不可用",
    serviceUnavailable: "服务暂时不可用",
    gatewayTimeout: "服务器无响应",
    serverErrorWithStatus: "服务器错误 ({status})",
  },

  // Dashboard
  dashboard: {
    title: "仪表板",
    subtitle: "集中管理系统概览",
    welcome: "欢迎回来",
    guestName: "访客",
    statusSummary: "当前状态概览",
    currentTimeLabel: "当前时间",
    todayLabel: "今天",
    activeCompanies: "活动公司",
    activeOrganizations: "活动组织",
    activeUsers: "在线用户",
    activeRoles: "活动角色",
    database: "数据库",
    databaseUsed: "已使用空间",
    recentlyAddedUsers: "最近添加的用户",
    recentlyAddedCompanies: "最近添加的公司",
    noUsersYet: "暂无用户",
    noCompaniesYet: "暂无公司",
    userPanel: "用户面板",
    userPanelWelcome: "欢迎！您可以从菜单访问用户设置。",
    quickActions: "快捷操作",
    systemHealthTitle: "系统健康度",
    systemLogsTitle: "系统日志",
    logChartTitle: "错误/警告分布",
    logErrorsLabel: "错误",
    logWarningsLabel: "警告",
    logSuccessLabel: "成功",
    statusHealthy: "健康",
    statusFailed: "失败",
    statusUnknown: "未知",
    lastRun: "最后运行",
    failures24h: "24h内失败",
    noData: "暂无数据",
    systemComponents: {
      EMAIL_INGEST: "接收邮件 (IMAP)",
      EMAIL_DISPATCH: "发送邮件 (SMTP)",
      JOB_SCHEDULER: "调度器",
      API: "API接口",
    },
  },

  // Sidebar
  sidebar: {
    dashboard: "仪表板",
    roles: "角色管理",
    users: "用户管理",
    settings: "设置中心",
    systemSettings: "系统设置",
    userSettings: "个人设置",
    organizations: "组织管理",
    logout: "登出系统",
    toggleMenu: "切换菜单",
    toggleMenuClose: "关闭菜单",
    management: "管理中心",
    companies: "公司管理",
    emailAccounts: "邮件账号",
    dataSources: "数据源",
    translations: "翻译管理",
  },

  // Settings
  settings: {
    title: "系统设置",
    subtitle: "管理公司和个人偏好",
    companySettingsSubtitle: "公司的通用配置",
    userSettingsSubtitle: "您的个人设置",
    securitySettingsSubtitle: "密码管理与安全",
    companySettings: "公司设置",
    userSettings: "个人设置",
    general: "通用",
    personal: "个人中心",
    timezone: "时区",
    dateFormat: "日期格式",
    defaultCurrency: "默认货币",
    defaultLanguage: "默认语言",
    language: "界面语言",
    companySettingsSaved: "公司设置已保存",
    userSettingsSaved: "个人设置已保存",
    failedToLoad: "加载设置失败",
    saveFailed: "保存设置失败",
    profilePicture: "个人头像",
    maxFileSize: "最大5MB。格式: JPEG, PNG, GIF, WebP",
    change: "更换",
    uploading: "正在上传...",
    deleteAvatar: "删除照片",
    deleteAvatarConfirm: "确认要删除头像吗？",
    avatarUploaded: "头像上传成功",
    avatarDeleted: "头像已删除",
    avatarUploadError: "头像上传错误",
    avatarDeleteError: "头像删除错误",
    onlyImageFiles: "仅限图片文件",
    fileSizeError: "文件大小不能超过5MB",
    appearance: "外观风格",
    theme: "主题颜色",
    light: "亮色",
    dark: "暗色",
    pageSize: "列表页大小",
    defaultCompany: "默认公司",
    selectDefaultCompany: "选择默认登录的公司",
    noCompaniesAssigned: "未分配公司",
    security: "账号安全",
    changePassword: "修改密码",
    currentPassword: "当前密码",
    newPassword: "新密码",
    confirmNewPassword: "确认新密码",
    passwordChanged: "密码修改成功",
    passwordChangeFailed: "密码修改失败",
    passwordMismatch: "新密码不匹配",
    passwordTooShort: "密码长度必须至少6位",
    passwordSameAsOld: "新密码必须与当前密码不同",
    changingPassword: "正在修改密码...",
    pleaseSelectCompany: "请选择公司",
  },

  // Organizations
  organizations: {
    title: "组织管理",
    code: "编号",
    name: "组织名称",
    description: "描述信息",
    logo: "标志",
    logoEmpty: "暂无标志",
    uploadLogo: "上传标志",
    status: "状态",
    smtp: "SMTP",
    imap: "IMAP",
    smtpEmailAccount: "SMTP邮件账号",
    imapEmailAccount: "IMAP邮件账号",
    active: "活动",
    inactive: "非活动",
    newOrganization: "新增组织",
    editOrganization: "编辑组织",
    deleteConfirm: "确认要删除该组织吗？",
    deleteFailed: "组织删除失败",
    operationFailed: "操作失败",
    failedToLoad: "加载组织失败",
    dataFormatError: "组织数据格式错误",
    searchPlaceholder: "搜索组织（名称、描述）",
    empty: "暂无数据",
    notSet: "未设置",
    noCreatePermission: "没有创建权限",
    noUpdatePermission: "没有编辑权限",
    noDeletePermission: "没有删除权限",
    company: "公司名称",
    statusDistribution: "组织状态分布",
  },

  // Users
  users: {
    title: "用户管理",
    newUser: "新增用户",
    editUser: "编辑用户",
    noUsersYet: "暂无用户",
    failedToLoad: "加载用户失败",
    deleteConfirm: "确认要删除该用户吗？",
    deleteFailed: "删除用户失败",
    operationFailed: "操作失败",
    passwordRequired: "密码是必填项",
    passwordChangeHint: "（如需更改请输入）",
    fullName: "全名",
    email: "电子邮箱",
    status: "状态",
    roles: "角色",
    actions: "动作",
    firstName: "名字 *",
    lastName: "姓氏 *",
    password: "登录密码",
    noRoles: "无角色",
    rolesNotFound: "找不到角色",
    statusActive: "显示",
    statusInactive: "隐藏",
    statusSuspended: "停用",
    userInfoFailed: "加载用户信息错误",
    rolesFailed: "加载角色错误",
    copy: "复制",
    isAdmin: "管理员",
    groups: "群组",
    groupCount: "群组数量",
    userGroupName: "群组名称",
    userGroupCode: "群组代码",
    userGroupEmail: "群组邮件",
    groupManager: "群组经理",
    members: "成员列表",
    userGroupDescription: "描述",
    userGroupCreate: "创建新群组",
    userGroupEdit: "编辑群组",
    manageMembers: "成员管理",
    addMember: "添加成员",
    memberCount: "成员数量",
    searchUsers: "搜索用户...",
    noMembers: "暂无成员",
    selectUser: "选择用户",
    addUser: "添加",
    removeUser: "移除",
    manageGroups: "群组管理",
    noUsersFound: "找不到用户",
    statusDistribution: "用户状态分布",
    groupStatusDistribution: "群组状态分布",
  },

  // Roles
  roles: {
    title: "角色管理",
    newRole: "新增角色",
    editRole: "编辑角色",
    noRolesYet: "暂无角色",
    failedToLoad: "加载角色失败",
    deleteConfirm: "确认要删除该角色吗？",
    deleteFailed: "角色删除失败",
    operationFailed: "操作失败",
    dataFormatError: "数据格式错误",
    permissionsFailed: "加载权限错误",
    name: "角色名称 *",
    description: "描述信息",
    permissions: "权限分配",
    permissionCount: "权限数量",
    type: "角色类型",
    typeSystem: "系统内置",
    typeCustom: "自定义",
    typeAll: "所有角色",
    searchPlaceholder: "搜索（角色名、描述、权限）...",
    systemBadge: "系统",
    permissionsCount: "权限 ({count})",
    morePermissions: "+ 另外 {count} 个",
    copy: "复制",
    copySuffix: " (副本)",
    clearFilters: "清除筛选",
    noCreatePermission: "没有创建权限",
    noUpdatePermission: "没有编辑权限",
    noDeletePermission: "没有删除权限",
    systemRoleEditBlocked: "内置系统角色不可编辑",
    systemRoleDeleteBlocked: "内置系统角色不可删除",
    noPermissions: "暂无权限",
    paginationRange: "第 {start}-{end} 条，共 {total} 条",
    paginationPage: "第 {page} / {total} 页",
    modules: {
      users: "用户管理",
      groups: "群组管理",
      userGroupName: "群组名称",
      userGroupCode: "群组代码",
      groupManager: "群组经理",
      members: "成员管理",
      userGroupDescription: "描述",
      userGroupCreate: "创建群组",
      userGroupEdit: "编辑群组",
      roles: "角色管理",
      tenant: "承租人",
      userSettingField: "配置项",
      settings: "设置中心",
      organizations: "组织管理",
    },
    groups: "群组",
    userGroup: "用户群组",
    userGroupList: "群组列表",
    userGroupCreate: "创建群组",
    userGroupEdit: "编辑群组",
    userGroupName: "名称",
    userGroupDescription: "描述",
    userGroupCode: "编码",
    groupManager: "群组经理",
    members: "成员",
    addMember: "添加成员",
    assignRole: "分配角色",
    assign: "分配",
    statusDistribution: "角色状态分布",
    assignRoleMatrix: "角色矩阵",
    roleMatrix: "权限矩阵",
    selectCompanyToViewMatrix: "选择公司以查看矩阵",
    show: "显示",
    hide: "隐藏",
    searchPermissions: "搜索权限...",
    permission: "权限项",
    permissionsSelected: "已选择 {count} 个权限项",
  },

  // Companies
  companies: {
    title: "公司管理",
    newCompany: "新增公司",
    editCompany: "编辑公司",
    noCompaniesYet: "暂无公司",
    failedToLoad: "加载公司失败",
    deleteConfirm: "确认要删除该公司吗？",
    deleteFailed: "公司删除失败",
    operationFailed: "操作失败",
    dataFormatError: "数据格式错误",
    name: "公司名称 *",
    status: "状态",
    statusActive: "启动",
    statusInactive: "停用",
    searchPlaceholder: "搜索（公司名、状态）...",
    clearFilters: "清除筛选",
    copy: "复制",
    copySuffix: " (副本)",
    noCreatePermission: "没有创建权限",
    noUpdatePermission: "没有编辑权限",
    noDeletePermission: "没有删除权限",
    paginationRange: "第 {start}-{end} 条，共 {total} 条",
    paginationPage: "第 {page} / {total} 页",
    allStatuses: "所有状态",
    statusDistribution: "公司状态分布",
    show: "显示",
    hide: "隐藏",
    logo: "标志",
    logoEmpty: "无标志",
    uploadLogo: "上传标志",
    smtpEmailAccount: "SMTP账号",
    imapEmailAccount: "IMAP账号",
    smtpEmailId: "SMTP账号",
    imapEmailId: "IMAP账号",
  },

  // Emails
  emails: {
    title: "邮件账号",
    newEmail: "新增账号",
    editEmail: "编辑账号",
    noEmailsYet: "暂无邮件账号",
    failedToLoad: "加载邮件账号失败",
    deleteConfirm: "确认删除该账号？",
    deleteConfirmMessage: "您确定要删除账号 \"{name}\" 吗？",
    deleteFailed: "删除失败",
    operationFailed: "操作失败",
    dataFormatError: "数据格式错误",
    name: "账号名称",
    type: "类型",
    host: "主机地址",
    port: "端口号",
    user: "用户名",
    password: "账号密码",
    fromEmail: "发件人邮箱",
    secure: "安全 (SSL/TLS)",
    secureConnection: "安全连接 (SSL/TLS)",
    status: "状态",
    statusActive: "启动",
    statusInactive: "停用",
    activate: "启用",
    deactivate: "禁用",
    isActive: "活动",
    searchPlaceholder: "搜索（名称、主机、用户）...",
    clearFilters: "清除筛选",
    copy: "复制",
    noCreatePermission: "没有创建权限",
    noUpdatePermission: "没有编辑权限",
    noDeletePermission: "没有删除权限",
    paginationRange: "第 {start}-{end} 条，共 {total} 条",
    paginationPage: "第 {page} / {total} 页",
    allStatuses: "所有状态",
    allTypes: "所有类型",
    statusDistribution: "账号状态分布",
    show: "显示",
    hide: "隐藏",
    nameRequired: "账号名称是必填项",
    hostRequired: "主机地址是必填项",
    portRequired: "端口是必填项",
    userRequired: "用户名是必填项",
    passwordRequired: "密码是必填项",
    leaveBlankToKeep: "留空保持原样",
    noData: "暂无数据",
    noEmailsMessage: "未发现邮件账号",
    passwordEditHint: "留空保持不变",
    noSearchResults: "搜索无结果",
    namePlaceholder: "例如：客户支持 或 info@company.cn",
    deleteConfirmTitle: "删除邮件账号",
  },

  // Login
  login: {
    title: "QubePro ERP",
    subtitle: "集中管理系统",
    heroTitle: "一站式企业数字化管理",
    heroSubtitle: "QubePro ERP 将公司、组织、用户和角色管理统一在一个安全的平台中。",
    languageToggleLabel: "多语言",
    turkish: "土耳其语",
    english: "英语",
    email: "电子邮箱",
    password: "登录密码",
    emailPlaceholder: "example@domain.cn",
    emailHint: "系统将通过域名自动识别承租人",
    passwordPlaceholder: "请输入密码",
    loginButton: "登录系统",
    loggingIn: "正在登录...",
    loginFailed: "登录失败",
    darkMode: "暗色模式",
    lightMode: "亮色模式",
    loginPageTitle: "用户登录",
    submitButton: "登录",
    featureTitle: "企业资源规划",
    featureDescription: "在一个集成平台上管理客户关系、销售、库存和财务流程。",
    featureCard1Title: "客户管理",
    featureCard1Description: "从中央位置跟踪您的客户、潜在销售和业务关系。",
    featureCard2Title: "销售与订单",
    featureCard2Description: "轻松管理报价、订单和销售流程，推动收入增长。",
    featureCard3Title: "报告与分析",
    featureCard3Description: "通过实时报告和仪表板监控业务绩效，做出数据驱动的决策。",
    featureCard4Title: "集成与设置",
    featureCard4Description: "自定义您的系统，与其他工具集成，并自动化您的业务流程。",
    pleaseWait: "请稍候",
    serverConfiguring: "服务器配置中，请稍候...",
    dbCreating: "正在创建数据库和必要配置，可能需要数秒。",
    emailLabel: "邮箱地址",
    passwordLabel: "登录密码",
    emailPlaceholderFull: "请输入您的电子邮箱",
    passwordPlaceholderFull: "请输入您的登录密码",
    showPassword: "显示密码",
    hidePassword: "隐藏密码",
    emailRequired: "邮箱是必选项",
    passwordRequired: "密码是必选项",
    backendUnavailable: "服务器不可用，请稍后再试。",
    backendConnectFailed: "连接服务器失败，请重试。",
    backendConnectFailedDev: "无法连接。请检查后端是否在运行 ({apiUrl})。",
    fieldEmail: "邮箱",
    fieldPassword: "密码",
    errors: {
      invalidCredentials: "邮箱或密码错误，请检查后再试。",
      databaseUnavailable: "数据库不可用或需要初始化设置，请重试。",
      accountInactive: "账号已停用，请联系您的系统管理员。",
      sessionExpired: "会话已过期，请重新登录。",
      tooManyAttempts: "尝试次数过多，请稍后再试。",
      sessionTooLarge: "数据过大导致异常，请重试。",
    },
  },

  // DataSources
  dataSources: {
    title: "数据源管理",
    subtitle: "管理与客户数据库的安全连接",
    newDataSource: "新增数据源",
    editDataSource: "编辑数据源",
    noDataSourcesYet: "暂无数据源",
    failedToLoad: "加载数据源失败",
    deleteConfirm: "确认要删除该数据源吗？",
    deleteFailed: "删除失败",
    operationFailed: "操作失败",
    dataFormatError: "数据格式错误",
    name: "显示名称",
    driver: "驱动类型",
    server: "地址",
    port: "端口",
    databaseName: "数据库名",
    username: "数据库用户名",
    password: "登录密码",
    schema: "模式/Schema",
    sourceType: "源类型",
    source: "来源",
    target: "目标",
    sourceSystem: "源系统",
    targetSystem: "目标系统",
    status: "状态",
    statusActive: "启动",
    statusInactive: "停用",
    searchPlaceholder: "搜索（名称、地址、数据库）...",
    clearFilters: "清除筛选",
    copy: "复制",
    paginationRange: "第 {start}-{end} 条，共 {total} 条",
    paginationPage: "第 {page} / {total} 页",
    allStatuses: "所有状态",
    allTypes: "全部",
    statusDistribution: "数据源状态分布",
    show: "显示",
    hide: "隐藏",
    nameRequired: "名称是必填项",
    serverRequired: "服务器地址是必填项",
    databaseRequired: "数据库名是必填项",
    passwordRequired: "密码是必填项",
    testConnection: "测试连接",
    testing: "测试中...",
    testSuccess: "连接测试成功！",
    testFailed: "连接失败: ",
    integratedSecurity: "集成安全验证",
    ssl: "SSL加密",
    connectionTimeout: "连接超时 (秒)",
    description: "描述信息",
    noCreatePermission: "没有创建权限",
    noUpdatePermission: "没有编辑权限",
    noDeletePermission: "没有删除权限",
  },

  aiProviders: {
    title: "AI提供商",
    subtitle: "管理AI模型与集成",
    newProvider: "新增AI提供商",
    editProvider: "编辑AI提供商",
    noProvidersYet: "暂无数据",
    failedToLoad: "加载AI提供商失败",
    deleteConfirm: "确认要删除此AI提供商吗？",
    deleteFailed: "删除AI提供商失败",
    operationFailed: "操作失败",
    name: "提供商名称 *",
    provider: "提供商类型",
    baseUrl: "基础URL",
    apiKey: "API密钥",
    description: "描述信息",
    status: "状态",
    statusActive: "已启用",
    statusInactive: "已停用",
    searchPlaceholder: "搜索（名称、类型、URL）...",
    clearFilters: "清除筛选",
    noCreatePermission: "您没有创建AI提供商的权限",
    statusDistribution: "AI提供商状态分布",
    baseUrlPlaceholder: "例如：http://localhost:11434, https://api.custom.ai/v1",
    baseUrlEmptyDefault: "留空使用默认值",
    apiKeyPlaceholder: "请输入API密钥",
  },
};
